/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ReviewAction from './ReviewAction/index'
import SubmitAction from './SubmitAction/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Action({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Progress/Content/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'ReviewAction'
let selectedIsCompleteValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'isComplete',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedIsCompleteValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'ReviewAction'}>
<ReviewAction
  viewPath={`${viewPath}/ReviewAction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SubmitAction'}>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}